import React, { memo } from "react";
import { PieChart, Pie, Cell } from "recharts";

const RADIAN = Math.PI / 180;

const cx = 200;
const cy = 200;
const iR = 120;
const oR = 180;

const needle = (
  value: any,
  data: any,
  cx: any,
  cy: any,
  iR: any,
  oR: any,
  color: any,
) => {
  let total = 0;
  data.forEach((v: any) => {
    total += v.value;
  });
  const ang = 180.0 * (1 - value / total);

  // Needle length: outer radius + 10px
  const length = oR + 20; // Needle extends 10 pixels beyond chart outer radius
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);

  // Circular base radius remains as 8
  const r = 8;
  const x0 = cx + 0;
  const y0 = cy + 0;
  const xba = x0 + r * sin;
  const yba = y0 - r * cos;
  const xbb = x0 - r * sin;
  const ybb = y0 + r * cos;
  const xp = x0 + length * cos;
  const yp = y0 + length * sin;

  return [
    <circle key="base" cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
    <path
      key="needle"
      d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
      stroke="none"
      fill={color}
    />,
  ];
};

const CrashRiskReductionPiChart = ({ value = 0 }) => {
  const numValue = Number(value) || 0;
  const data = [
    { name: "filled", value: numValue },
    { name: "rest", value: 100 - numValue },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      <PieChart width={400} height={220}>
        <defs>
          <linearGradient id="gradientColor" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style={{ stopColor: "#0088FE", stopOpacity: 1 }}
            />
            <stop offset="100%" stopColor="#006AFF" />
          </linearGradient>
        </defs>
        <Pie
          dataKey="value"
          startAngle={180}
          endAngle={0}
          data={data}
          cx={cx}
          cy={cy}
          innerRadius={iR}
          outerRadius={oR}
          stroke="none"
        >
          <Cell key="filled" fill="url(#gradientColor)" />
          <Cell key="rest" fill="#262626" />
        </Pie>
        {needle(numValue, data, cx, cy, iR, oR, "#fff")}
      </PieChart>
      <div
        className={"flex justify-between items-center text-white px-6 !text-base gap-2"}
      >
        <p className={"w-14"}>0%</p>
        <p className={"text-3xl font-bold text-sidebarSelectText"}>{numValue.toFixed(2)} %</p>
        <p className={"w-14 text-right"}>100%</p>
      </div>
    </div>
  );
};

export default memo(CrashRiskReductionPiChart);
